'use client';

import { RecaptchaProvider } from '@/components/shared/RecaptchaProvider';
import FooterNewsletter from './FooterNewsletter';

interface Props {
    domain: string;
    companyId: string;
}

const FooterNewsletterRedesignWrapper = ({ domain, companyId }: Props) => {
    return (
        <RecaptchaProvider domain={domain}>
            <FooterNewsletter domain={domain} companyId={companyId} />
        </RecaptchaProvider>
    );
};

export default FooterNewsletterRedesignWrapper;
